import script from "./commodity.vue?vue&type=script&setup=true&lang=js"
export * from "./commodity.vue?vue&type=script&setup=true&lang=js"

import "./commodity.vue?vue&type=style&index=0&id=d495be3c&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d495be3c"]])

export default __exports__